import React, { useEffect } from 'react';
import { SearchVendorIcon } from '../../../../assets/svg';
import Icon from '../../../../generic-components/Icon';
import { IAppCenterCategory, IVendor } from '../../../../types';

interface IProps {
  originalList: IAppCenterCategory[];
  setCategoriesList: React.Dispatch<React.SetStateAction<IAppCenterCategory[]>>;
  setSearchInput: React.Dispatch<React.SetStateAction<string>>;
  searchInput: string;
  setSearchResults: React.Dispatch<React.SetStateAction<IVendor[]>>;
  selectedCategoryIndex: number;
}

const SearchBar = (props: IProps) => {
  const { setCategoriesList, originalList, setSearchInput, searchInput, setSearchResults, selectedCategoryIndex } =
    props;

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentSearchInput = e.target.value;
    setSearchInput(currentSearchInput);
    const currentResults: IVendor[] = [];
    const newCategoriesList = JSON.parse(JSON.stringify(originalList));

    if (currentSearchInput === '') {
      setSearchResults([]);
      setCategoriesList(originalList);
    } else {
      newCategoriesList.forEach((c: IAppCenterCategory, index: number) => {
        const tmp: IVendor[] = [];
        c.vendors.forEach((v: IVendor) => {
          if (v.vendorName.toLocaleLowerCase().includes(currentSearchInput.toLocaleLowerCase())) {
            tmp.push(v);
            currentResults.push(v);
          }
        });
        newCategoriesList[index].vendors = tmp;
      });
      setSearchResults(currentResults);
      setCategoriesList(newCategoriesList);
    }
  };

  useEffect(() => {
    setSearchInput('');
    setCategoriesList(originalList);
  }, [selectedCategoryIndex]);

  return (
    <div className='flex items-center relative ml-[10.5rem] pc-sm:ml-[10.375rem]'>
      <input
        id='appCenterSearchBar'
        name='appCenterSearchBar'
        type='text'
        className='h-[46px] w-[327px] bg-bw00 rounded-[8px] pl-[36px] pr-[10px] py-[11px] text-bw08 font-metricR placeholder-bw05 focus:outline-none focus:border focus:border-action03 border border-outline-primary-bw-03'
        placeholder='Search'
        value={searchInput}
        onChange={handleSearchChange}
        autoComplete='off'
      />
      <Icon src={SearchVendorIcon} className='absolute left-[14px]' />
    </div>
  );
};

export default SearchBar;
